/* eslint-disable import/prefer-default-export */
import styled from "styled-components";
import * as palette from "../../config/colors";

const c = (theme, key, fallback) => theme?.colors?.[key] ?? fallback;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 680px; /* força scroll no mobile quando precisar */

  th {
    text-align: left;
    padding: 12px 12px;
    background: ${({ theme }) => c(theme, "appBackground", palette.primaryDarkColor)};
    color: #fff;
    font-weight: 800;
    font-size: 0.9rem;
    white-space: nowrap;
  }

  tr:hover {
      background: ${({ theme }) => c(theme, "primarySoft", palette.lightGrayColor)};
      cursor: pointer;
   }

  td {
    padding: 10px 12px;
    border-top: 1px solid ${({ theme }) => c(theme, "border", palette.lightBgText)};
    vertical-align: middle;
    font-size: 0.75rem;
  }

  td.center, th.center {
    text-align: center;
  }
`;
